import { createSelector } from 'reselect'
import { get } from 'utils/lodash'
import { getAccountMetaSlice } from 'api/meta/getAccountMeta'

export const getAccountMeta = createSelector(getAccountMetaSlice, (meta = {}) => get(meta, 'data', []))
